import React from 'react';

import Colors, { type ColorValues } from 'common/colors/constants';
import { cn } from 'common/style/utils';
import { P } from 'common/ui/Text';
import styles from 'css-module/components/common/_Pill.module.scss';

export type PillStyle = {
  color: ColorValues;
  background: ColorValues;
  border?: ColorValues;
};

type PillStyleName = 'beta' | 'canny' | 'destructive' | 'info' | 'success' | 'warning';

export const DefaultPillStyles: Record<PillStyleName, PillStyle> = {
  beta: {
    color: Colors.purple110,
    background: Colors.purple30,
  },
  canny: {
    color: Colors.indigo90,
    background: Colors.indigo30,
  },
  destructive: {
    color: Colors.red90,
    background: Colors.red30,
  },
  info: {
    color: Colors.gray110,
    background: Colors.gray30,
  },
  success: {
    color: Colors.grass110,
    background: Colors.grass30,
  },
  warning: {
    color: Colors.yellow110,
    background: Colors.yellow30,
  },
};

type Props = {
  children: React.ReactNode;
  className?: string;
  centered?: boolean;
  pillStyle?: PillStyle; // receive colors instead of color names for flexibility (e.g., support for company-tinted pills)
  prefixIcon?: React.ReactElement | null;
};

const Pill = ({
  children,
  className,
  pillStyle = DefaultPillStyles.canny,
  prefixIcon,
  centered = false,
}: Props) => {
  return (
    <div
      className={cn(styles.pill, className, 'box-border', {
        [styles.centered]: centered,
        [styles.border]: !!pillStyle.border,
      })}
      style={{
        color: pillStyle.color,
        background: pillStyle.background,
        borderColor: pillStyle.border,
      }}>
      {prefixIcon}
      <P variant="bodySm" fontWeight="medium" className="truncate">
        {children}
      </P>
    </div>
  );
};

export default Pill;
